export default __webpack_public_path__ + "assets/banner.c225aef6.jpg";